import { TYPES } from "../../../config/constants/typesReducers";
import LocalStorage from "../../../ui/utils/LocalStorage";
import generateContrastColor from "../../../ui/utils/generateFieldColors";
import colors from "../../../config/constants/defaultColors";
import generateFieldColors from "../../../ui/utils/generateFieldColors";
import { FddApi } from "../../../ui/services/server-fdd";

const { DRAFT } = TYPES;

const signerId = new Date().getTime();

export const initialStateDraft = {
  conf:{
    canEdit: false,
  },
  draft: {
    title: '',

    signers: {
      [signerId]: {
        id: signerId,
        email: "",
        name: "",
        color: {
          background: '#adb6e6', 
          contrast: '#1b295a'
        },
      },
    },

    fieldsByPage:{},

    subject: {
      header: "",
      description: "",
    },
  },
};

// Función para obtener el estado inicial (carga asíncrona)
export const getDraft = async (draftId) => {
  const localDraft = LocalStorage.getLocalDraft();

  console.log('[GET initialStateDraft]', localDraft);

  // Si existe un draft en localStorage
  if (localDraft) {
    const { draft, draftId: oldDraftId  } = localDraft;
    // Si el draft guardado coincide con el borrador solicitado en la url (draftId), lo carga
    if (oldDraftId !== draftId) return FddApi.updateDraft(oldDraftId, draft);
    console.log("[INITIAL STATE] Se ha obtenido el draft de LS -> ", draft);

    LocalStorage.setLocalDraft({
      isFinished: false,
      draftId: draftId,
      draft
    })
    return draft;
  }

  // Consultar datos en la API
  const response = await FddApi.getDraftData(draftId);

  // Si no existe en localStorage pero sí en la base de datos
  if (!response.hasError) {
    console.log("[INITIAL STATE] Se ha obtenido el draft de BD-> ", response.body);
    const draft = response.body;

    LocalStorage.setLocalDraft({
      isFinished: false,
      draftId: draftId,
      draft
    })
    return draft;
  }

  throw new Error("No se pudo obtener el borrador");
};

export const draftReducer = (
  initialState,
  action = { type: "", payload: "" }
) => {
  switch (action.type) {
    
    case DRAFT.CAN_EDIT: {
      //console.log('Can edit render', action.payload);
      return {
        ...initialState,
        conf:{
          canEdit: action.payload,
        }
      };
    }

    case DRAFT.LOAD_DRAFT: {
      const draftLoaded = action.payload;
      
      // Si el draft cargado está vacío o no tiene signers, usar estructura inicial
      const isEmptyDraft = !draftLoaded || Object.keys(draftLoaded).length === 0;
      const mergedDraft = isEmptyDraft 
        ? initialStateDraft.draft 
        : { ...initialStateDraft.draft, ...draftLoaded };
      
      const { signers = {} } = mergedDraft;
      const signersArray = Object.values(signers);

      const fieldColorsCopy = initialState.conf.defaultColors;
      
      if( signersArray.length > colors.length ){

        const fieldColorsLength = fieldColorsCopy.length

        if (signersArray.length > fieldColorsLength){
          for (let i = 0; i < signersArray.length; i++) {
            if (i < fieldColorsLength) continue;
            const {background, contrast} = generateContrastColor();
            fieldColorsCopy.push({
              background, contrast
            })
          }
        } else if ( signersArray.length < fieldColorsLength ){
          for (let i = 0; i < signersArray.length; i++) {
            if (i > fieldColorsLength) continue;
            fieldColorsCopy.pop();
          }
        }
      }
      
      return {
        ...initialState,
        draft: mergedDraft
      }
    }

    case DRAFT.TITLE: 
      //console.log('entro a reducer', action.payload);
      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          title: action.payload
        },
      };

    case DRAFT.ADD_SIGNER: {
      const { background, contrast } = generateFieldColors();
      const signerId = new Date().getTime();

      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          signers: {
            ...initialState.draft.signers,
            [signerId]: {
              id: signerId,
              email: '',
              name: '',
              color: {
                background, 
                contrast
              },
            }
          }
        }
      }
    }

    case DRAFT.EDIT_SIGNER: {
      const {signerId, name, value} = action.payload;

      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          signers:{
            ...initialState.draft.signers,
            [signerId]: {
              ...initialState.draft.signers[signerId],
              [name]: value,  // Se actualiza la informacion del firmante
            }
          }
        }
      }
    }

    case DRAFT.REMOVE_SIGNER: {
      const signerId = action.payload;
      const signersCopy = {... initialState.draft.signers};
      const copyFieldsByPage = {... initialState.draft.fieldsByPage};

      Object.keys(copyFieldsByPage).forEach((page) => {
        copyFieldsByPage[page] = { ...copyFieldsByPage[page] };
        Object.keys(copyFieldsByPage[page]).forEach((fieldId) => {
          if (copyFieldsByPage[page][fieldId]?.signerId === signerId) {
            delete copyFieldsByPage[page][fieldId];
          }
        });
      });

      console.log('signersCopy', signersCopy);
      console.log('signersCopy', delete signersCopy[signerId]);

      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          signers: signersCopy,
          fieldsByPage: copyFieldsByPage
        }
      }
    }

    case DRAFT.ADD_FIELD: {
      const { field, page } = action.payload;

      const fieldId = new Date().getTime();
      //console.log("Entro al reducer");
      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          fieldsByPage:{
            ...initialState.draft.fieldsByPage,
            [page]: {
              ...initialState.draft.fieldsByPage[page],
              [fieldId]:{
                ...field,
                id: fieldId,
              }
            }
          }
        }
      }
    }

    // Argumentos: signerId, fieldId, coords
    case DRAFT.MOVE_FIELD: {
      const { fieldId, coords, page } = action.payload;

      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          fieldsByPage:{
            ...initialState.draft.fieldsByPage,
            [page]: {
              ...initialState.draft.fieldsByPage[page],
              [fieldId]:{
                ...initialState.draft.fieldsByPage[page][fieldId],
                position:{
                  ...initialState.draft.fieldsByPage[page][fieldId].position,
                  coords
                }
              }
            }
          }
        }
      }
    }

    case DRAFT.RESIZE_FIELD: {
      const { fieldId, size, page } = action.payload;

      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          fieldsByPage:{
            ...initialState.draft.fieldsByPage,
            [page]: {
              ...initialState.draft.fieldsByPage[page],
              [fieldId]:{
                ...initialState.draft.fieldsByPage[page][fieldId],
                position:{
                  ...initialState.draft.fieldsByPage[page][fieldId].position,
                  size
                }
              }
            }
          }
        }
      }
    }

    case DRAFT.REMOVE_FIELD: {
      const { fieldId, page } = action.payload;
      const fieldsCopy = initialState.draft.fieldsByPage[page];

      delete fieldsCopy[fieldId];

      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          fieldsByPage: {
            ...initialState.draft.fieldsByPage,
            [page]: fieldsCopy
          }
        }
      };
    }

    case DRAFT.EDIT_FIELD_DATE_FORMAT: {
      const { fieldId, page, dateFormat } = action.payload;
      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          fieldsByPage: {
            ...initialState.draft.fieldsByPage,
            [page]: {
              ...initialState.draft.fieldsByPage[page],
              [fieldId]: {
                ...initialState.draft.fieldsByPage[page][fieldId],
                dateFormat,
              }
            }
          }
        }
      };
    }

    case DRAFT.SUBJECT: {
      return {
        ...initialState,
        draft: {
          ...initialState.draft,
          subject: action.payload,
        },
      };
    }

    case DRAFT.CLEAN:
      return {
        ...initialStateDraft,
      };

    default:
      return initialState;      
  }
};